import { ApeironCloseButton, noForwardProps } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import ApeironScrollBox from '@src/components/share/apeiron/ApeironScrollBox'
import { FC, forwardRef, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

const Container = styled(ApeironScrollBox)`
  display: flex;
  flex-direction: column;
  background-color: #dfdfdf;
  height: 100%;
  border-radius: 10px 10px 0px 0px;
`

const Header = styled(Box)`
  display: flex;
  position: relative;
  justify-content: center;
`

const Title = styled(Typography)`
  padding: 16px 0px;
  line-height: 1;
  font-size: 20px;
  color: black;
`

const CloseButton = styled(ApeironCloseButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
  width: 20px;
`

const ContentContainer = styled(Box, noForwardProps)<ContentContainerProps>`
  ${props => (props.__noScroll ? 'overflow-y: hidden' : 'overflow-y: scroll')}
`

/**
 * This component is wrapped by Slide from mui/material
 * Which is a transition component that require its children to forward ref
 * Reference: https://github.com/mui/material-ui/issues/11908
 */

const FilterScrollBox: FC<Props> = forwardRef((props: Props, ref) => {
  const {
    children,
    className,
    title,
    tabIndex,
    onClose,
    noScroll = false
  } = props

  const { t } = useTranslation()

  return (
    <Container className={className} ref={ref} tabIndex={tabIndex}>
      <Header>
        <Title>{title || t('common.button.filter')}</Title>
        <CloseButton onClick={onClose} />
      </Header>
      <ContentContainer __noScroll={noScroll}>{children}</ContentContainer>
    </Container>
  )
})

FilterScrollBox.displayName = 'FilterScrollBox'

type Props = {
  children: ReactNode
  className?: string
  title?: string
  tabIndex?: number
  onClose?: () => void
  noScroll?: boolean
}

type ContentContainerProps = {
  __noScroll?: boolean
}

export default FilterScrollBox
